import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'
import constants from '../lib/constants'

class doubleSideSwiper {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.strip = jQuery(element)
    this.swiper = null
    this.previousIsDesktop = null

    // Bind resize handler to maintain context
    this.resizeHandler = this.handleResize.bind(this)

    // Initialize swiper
    this.initSwiper()

    // Add resize listener to reinitialize when viewport changes
    window.addEventListener('resize', this.resizeHandler)
  }

  initSwiper() {
    // Determine which navigation to use based on viewport
    const isDesktop = constants.is === 'desktop'

    // Select the appropriate navigation buttons based on viewport
    let nextEl, prevEl
    if (isDesktop) {
      nextEl = this.strip.find('.s-multi-img-slider__next-desktop')[0]
      prevEl = this.strip.find('.s-multi-img-slider__prev-desktop')[0]
    } else {
      nextEl = this.strip.find('.s-multi-img-slider__next-mobile')[0]
      prevEl = this.strip.find('.s-multi-img-slider__prev-mobile')[0]
    }

    this.swiper = new Swiper(this.strip.find('.swiper')[0], {
      direction: 'horizontal',
      effect: 'slide',
      centeredSlides: false,
      breakpoints: {
        320: {
          slidesPerView: 1.05,
          spaceBetween: 8,
        },
        576: {
          slidesPerView: 1.5,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 2.05,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 2.5,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3.25,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1366: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: this.strip.find('.swiper-pagination')[0],
        type: 'bullets',
        clickable: true,
      },
    })
  }

  handleResize() {
    const isDesktop = constants.is === 'desktop'

    // Only reinitialize if viewport type changed (desktop <-> mobile/tablet)
    if (
      this.previousIsDesktop !== null &&
      this.previousIsDesktop !== isDesktop
    ) {
      // Destroy existing swiper
      if (this.swiper) {
        this.swiper.destroy(true, true)
      }

      // Reinitialize with new navigation
      this.initSwiper()
    }

    this.previousIsDesktop = isDesktop
  }
}

export default doubleSideSwiper
